export default __webpack_public_path__ + "static/media/seven-car.df8bde69.svg";